var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 4.99987L5.41819 6.0829C5.11569 6.1434 4.96444 6.17365 4.84127 6.24721C4.73238 6.31224 4.63977 6.40127 4.5705 6.50751C4.49214 6.62768 4.45595 6.77762 4.38356 7.07749L1.66667 18.3332M1.66667 18.3332L12.9224 15.6163C13.2223 15.5439 13.3722 15.5077 13.4924 15.4294C13.5986 15.3601 13.6876 15.2675 13.7527 15.1586C13.8262 15.0354 13.8565 14.8842 13.917 14.5817L15 9.16654M1.66667 18.3332L7.98833 12.0115M17.3905 6.55707L13.4428 2.60935C13.1128 2.27934 12.9478 2.11433 12.7575 2.0525C12.5901 1.99812 12.4099 1.99812 12.2425 2.05251C12.0522 2.11433 11.8872 2.27934 11.5572 2.60935L10.9428 3.22373C10.6128 3.55375 10.4478 3.71875 10.386 3.90903C10.3316 4.0764 10.3316 4.25669 10.386 4.42406C10.4478 4.61433 10.6128 4.77934 10.9428 5.10935L14.8905 9.05707C15.2205 9.38708 15.3855 9.55209 15.5758 9.61391C15.7432 9.66829 15.9235 9.66829 16.0908 9.61391C16.2811 9.55209 16.4461 9.38708 16.7761 9.05706L17.3905 8.44268C17.7205 8.11267 17.8855 7.94766 17.9474 7.75739C18.0018 7.59002 18.0018 7.40973 17.9474 7.24236C17.8855 7.05209 17.7205 6.88708 17.3905 6.55707ZM9.16667 9.16654C10.0871 9.16654 10.8333 9.91273 10.8333 10.8332C10.8333 11.7537 10.0871 12.4999 9.16667 12.4999C8.24619 12.4999 7.5 11.7537 7.5 10.8332C7.5 9.91273 8.24619 9.16654 9.16667 9.16654Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCreate);
export default __webpack_public_path__ + "static/media/action-create.f9f53057a023e699772170786ec2bd90.svg";
export { ForwardRef as ReactComponent };